export const GET_DEALER_LIST_REQUEST = 'GET_DEALER_LIST_REQUEST';
export const GET_DEALER_LIST_SUCCESS = 'GET_DEALER_LIST_SUCCESS';
export const GET_DEALER_LIST_FAILURE = 'GET_DEALER_LIST_FAILURE';

export const DEALER_SEARCH_REQUEST = 'DEALER_SEARCH_REQUEST';
export const DEALER_SEARCH_SUCCESS = 'DEALER_SEARCH_SUCCESS';
export const DEALER_SEARCH_FAILURE = 'DEALER_SEARCH_FAILURE';

export const ADD_DEALER_REQUEST = 'ADD_DEALER_REQUEST';
export const ADD_DEALER_SUCCESS = 'ADD_DEALER_SUCCESS';
export const ADD_DEALER_FAILURE = 'ADD_DEALER_FAILURE';

export const UPDATE_DEALER_STATUS_REQUEST = 'UPDATE_DEALER_STATUS_REQUEST';
export const UPDATE_DEALER_STATUS_SUCCESS = 'UPDATE_DEALER_STATUS_SUCCESS';
export const UPDATE_DEALER_STATUS_FAILURE = 'UPDATE_DEALER_STATUS_FAILURE';

export const DEALER_COUNTRY_LIST_REQUEST = 'DEALER_COUNTRY_LIST_REQUEST';
export const DEALER_COUNTRY_LIST_SUCCESS = 'DEALER_COUNTRY_LIST_SUCCESS';
export const DEALER_COUNTRY_LIST_FAILURE = 'DEALER_COUNTRY_LIST_FAILURE';

export const RESET_DEALER_SEARCH = 'RESET_DEALER_SEARCH';
export const RESET_SNACKBAR = 'RESET_SNACKBAR';

export const SEARCH_OBJ = {
  name: { text: '', order_by: '' },
  city: { text: '', order_by: '' },
  state: { text: '', order_by: '' },
  country: { text: '', order_by: '' },
  status: { text: '', order_by: '' }
};
